import React from "react";
import { getProgressTextColors } from "./textColors";
import { useTheme } from "../../contexts/ThemeContext";
import { useAuth } from "../../contexts/AuthContext";
import { getFeedback } from "../../services/moodle/courses";

export const ProgressCardItemDetail = ({ detail, includeFeedback, index }) => {
  const [feedback, setFeedback] = React.useState("-");
  const [generalFeedback, setGeneralFeedback] = React.useState("-");

  const theme = useTheme();
  const textColors = getProgressTextColors(theme.mode);
  const isDark = theme.mode === "dark";
  const { user } = useAuth();

  React.useEffect(() => {
    if (detail.feedback && detail.feedback !== "") {
      setFeedback(detail.feedback);
    }

    if (
      detail.itemmodule === "quiz" &&
      detail.graderaw !== null &&
      detail.graderaw !== undefined &&
      detail.iteminstance
    ) {
      const args = {
        token: user.token,
        quizid: detail.iteminstance,
        grade: detail.graderaw,
      };
      getFeedback(args)
        .then((res) => {
          if (res?.feedbacktext) {
            setGeneralFeedback(res.feedbacktext);
          }
        })
        .catch((err) => {
          console.error("Error fetching quiz feedback:", err);
        });
    }
  }, [detail, user.token]);

  const gradeFormatted =
    detail.gradeformatted && detail.gradeformatted.split("(")[0];

  return (
    <div
      className="flex flex-col p-4 rounded-xl transition-all"
      style={{
        backgroundColor: isDark ? "rgba(255, 255, 255, 0.03)" : "#FFFFFF",
        border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)"}`,
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <div className="flex items-start justify-between gap-3 mb-2">
        <h4
          className="font-bold text-sm leading-snug m-0"
          style={{ color: textColors.primary }}
        >
          {detail.itemname}
        </h4>
        <div
          className="font-bold text-sm shrink-0 px-2.5 py-1 rounded-md"
          style={{
            backgroundColor: isDark ? "rgba(236, 178, 54, 0.15)" : "#FEF3C7",
            color: "#ecb236",
          }}
          dangerouslySetInnerHTML={{ __html: gradeFormatted || "-" }}
        />
      </div>

      {includeFeedback && (feedback !== "-" || generalFeedback !== "-") && (
        <div
          className="text-xs mt-2 pt-2 flex flex-col gap-1"
          style={{
            borderTop: `1px solid ${isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)"}`,
            color: textColors.secondary,
          }}
        >
          {feedback !== "-" && (
            <div dangerouslySetInnerHTML={{ __html: feedback }} />
          )}
          {generalFeedback !== "-" && (
            <div dangerouslySetInnerHTML={{ __html: generalFeedback }} />
          )}
        </div>
      )}
    </div>
  );
};
